import { AbstractControl, Validator, FormGroup } from '@angular/forms';
import { InvoiceLabelType } from '../../model/invoice-label-type';
import { InvoiceCashDesk, InvoiceCashDeskTotals } from '../../model/invoice-cash-desk';
import { InvoiceCashDeskPayment } from '../../model/invoice-cash-desk-payment';
import { InvoicePointSelectManualType } from '../../model/invoice-point-select-manual-type';
import { setInValidControl, setValidControl } from '../validaror-invalid-control';


export function paymentValidator(control: AbstractControl) {
  return { validPayment: true };
}

export function invoiceCashDeskValidator(control: FormGroup) {

  console.log(control);

  if (control.value) {
    const invoiceCashDesk = <InvoiceCashDesk>control.getRawValue();
    const invoiceCashDeskTotals = new InvoiceCashDeskTotals(invoiceCashDesk);

    setValidControl(control.controls['Amount']);
    setValidControl(control.controls['TaxpayerType']);
    setValidControl(control.controls['InvoiceLabelType']);
    setValidControl(control.controls['Description']);
    setValidControl(control.controls['BusinessName']);
    setValidControl(control.controls['Service']);

    if (!invoiceCashDesk.Amount || invoiceCashDesk.Amount <= 0) {
      setInValidControl(control.controls['Amount']);
    }

    if (!invoiceCashDesk.TaxpayerType) {
      setInValidControl(control.controls['TaxpayerType']);
    }

    if (!invoiceCashDesk.InvoiceLabelType) {
      setInValidControl(control.controls['InvoiceLabelType']);
    }

    if (!invoiceCashDesk.Number) {
      return { validNumber: true };
    }

    if (invoiceCashDesk.InvoiceId && !invoiceCashDesk.Description) {
      setInValidControl(control.controls['Description']);
    }

    if (invoiceCashDesk.InvoiceLabelType && invoiceCashDesk.InvoiceLabelType.ClientRequired && !invoiceCashDesk.ClientSearch) {
      return { validClient: true };
    }

    if (invoiceCashDesk.Amount && invoiceCashDeskTotals.getTotalPayment() !== invoiceCashDeskTotals.getTotalAmount()) {
      return { validTotalPayment: true };
    }

    if (!invoiceCashDesk.BusinessName) {
      setInValidControl(control.controls['BusinessName']);
    }

    if (control.controls['IsManual'].value && (<boolean>control.controls['IsManual'].value) === true) {
      if (!invoiceCashDesk.Document && control.controls['InvoicePointSelectManualType'].value) {
        setInValidControl(control.controls['Document']);
      }

      if (control.controls['InvoicePointSelectManualType'].value
        && !invoiceCashDesk.ServiceManual
        && (<InvoicePointSelectManualType>control.controls['InvoicePointSelectManualType'].value).Id === 2) {
        setInValidControl(control.controls['ServiceManual']);
      }

      if (control.controls['InvoicePointSelectManualType'].value
        && !invoiceCashDesk.Service
        && (<InvoicePointSelectManualType>control.controls['InvoicePointSelectManualType'].value).Id === 1) {
        setInValidControl(control.controls['Service']);
      }
    }

      return null;

  } else {
    return null;
  }

}

export const validPaymentCard = (control: FormGroup): { [key: string]: boolean } => {

  let valid = true;

  if (control && control.controls && control.controls['PaymentAmount'].value > 0) {

    if (!control.controls['Dues'].value) {
      setInValidControl(control.controls['Dues']);
      valid = false;
    }

    if (!control.controls['BankFilter'].value) {
      setInValidControl(control.controls['BankFilter']);
      valid = false;
    }

    if (!control.controls['CreditCardFilter'].value) {
      setInValidControl(control.controls['CreditCardFilter']);
      valid = false;
    }

    if (!control.controls['CreditCardNumber'].value) {
      setInValidControl(control.controls['CreditCardNumber']);
      valid = false;
    }

    if (!control.controls['Coupon'].value) {
      setInValidControl(control.controls['Coupon']);
      valid = false;
    }
  }

  if (!valid) {
    return { validPayment: true };
  } else {
    setValidControl(control.controls['CreditCardFilter']);
    setValidControl(control.controls['CreditCardNumber']);
    setValidControl(control.controls['Coupon']);
    setValidControl(control.controls['Dues']);
    setValidControl(control.controls['BankFilter']);
    return null;
  }
};

export const validPaymentCheck = (control: FormGroup): { [key: string]: boolean } => {

  let valid = true;

  if (control && control.controls && control.controls['PaymentAmount'].value > 0) {

    if (!control.controls['BankFilter'].value) {
      setInValidControl(control.controls['BankFilter']);
      valid = false;
    }

    if (!control.controls['CheckNumber'].value) {
      setInValidControl(control.controls['CheckNumber']);
      valid = false;
    }
  }

  if (!valid) {
    return { validPayment: true };
  } else {
    setValidControl(control.controls['CheckNumber']);
    setValidControl(control.controls['BankFilter']);
    return null;
  }
};

export const validPaymentTransfer = (control: FormGroup): { [key: string]: boolean } => {

  let valid = true;

  if (control && control.controls && control.controls['PaymentAmount'].value > 0) {

    if ( !control.controls['TranseferNumber'].value && !control.controls['VirtualWalletFilter'].value) {
      setInValidControl(control.controls['TranseferNumber']);
      valid = false;
    }
  }

  if (!valid) {
    return { validPayment: true };
  } else {
    setValidControl(control.controls['TranseferNumber']);
    return null;
  }
};
